<div #bodyWrapper class="section">
    <app-bread-crumb [links]="[
    {
      'href': '/dashboard',
      'title': 'Dashboard'
    }
    ]"></app-bread-crumb>
    <p class="paragraph">Page is currently under development</p>
    </div>